<!--
 * @Author: lan.h
 * @Date: 2022-02-14 16:45:37
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-13 15:51:48
 * @Description: 文章
-->
<template>
  <div class="article">
    <div class="article-content">
      <div class="spc_img">
        <a @click="toArticle" :href="$store.state.index2_path + '/' + item.id" target="_blank">
          <img :src="item.logoPath | logo_show"/>
          <div class="play" v-if="item.type == 1"><i class="iconfont">&#xe60f;</i></div>
          <div class="duration" v-if="item.duration > 0">{{item.duration | time_deal}}</div>
        </a>
        <i class="iconfont collect-icon active" title="取消收藏" v-if="item.isCollect" @click.stop="cancelCollect('4', item.id, delCollectCb)">&#xe66f;</i>
        <i class="iconfont collect-icon" title="收藏" v-if="!item.isCollect" @click.stop="addCollect('4', item.id, addCollectCb)">&#xe66f;</i>
        <span class="icon_column" v-if="item.type == 0">
          <template v-if="isCollect">文章</template>
          <template v-if="!isCollect && item.categoryId">{{item.categoryId | dealNeed(category)}}</template>
        </span>
        <span class="icon_column" v-if="item.type == 1">视频</span>
      </div>
      <div class="spc_cnt">
        <a class="h1 over-p2" @click="toArticle" :href="$store.state.index2_path + '/' + item.id" target="_blank">{{item.title}}</a>
        <h2 class="over-p1">{{item.summary}}</h2>
        <div class="bot_cnt">
          <div>
            <div class="tags1" v-if="item.tracks && item.tracks.length > 0">
              <span>相关赛道</span>
              <a v-for="tag,tag_index in item.tracks" :key="tag" v-if="tag_index < 3" @click="toTrack(tag)">{{tag | dealNeed(entityNtag)}}</a>
            </div>
            <!-- <div class="tags2" v-if="item.tags && item.tags.length > 0">
              <span>文章标签</span>
              <a v-for="tag,tag_index in item.tags" :key="tag" v-if="tag_index < 3" :href="$store.state.index2_path + '/Article/labelList/keyword/' + tag" target="_blank">{{tag | dealNeed(mediaTag)}}</a>
            </div> -->
          </div>
          <div class="auth_time">
            <img v-if="item.authorInfo" :src="item.authorInfo.logoPath | logo_show('', $store.state.static_img_url + 'pic/vcbeat/no_face.jpg')" @click="toAuthor(item.authorInfo)"/>
            <span v-if="item.authorInfo" class="author" @click="toAuthor(item.authorInfo)">{{item.authorInfo.name}}</span>
            <span>{{item.publishTime | time_standard}}</span>
          </div>
        </div>
      </div>
    </div>
    <Entity v-if="item.entityInfos && item.entityInfos.length > 0" :entityInfos="item.entityInfos"></Entity>
  </div>
</template>

<script>
import { collect_mixin } from "js/collect_mixin";
import Entity from './Entity'
export default {
  mixins: [collect_mixin],
  props: ['item', 'mediaTag', 'entityNtag', 'category', 'itemIndex', 'isCollect'],
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  methods: {
    addCollectCb() {
      this.item.isCollect = true
    },
    delCollectCb() {
      this.item.isCollect = false
    },
    toArticle(a) {
      if(this.itemIndex && this.itemIndex < 3){
        let type = '左侧信息流(第' + (this.itemIndex + 1) + '块位置标题/图片)'
        _czc.push(['_trackEvent', '首页(新)', type, '点击量'])
      }
    },
    toAuthor(a) {
      const href = this.$store.state.index2_path + '/Article/authorArticle/keyword/' + a.id
      window.open(href, '_blank')
    },
    toTrack(tag) {
      const href = this.$store.state.index_path + '/trackDetail?tag=' + tag
      window.open(href, '_blank')
    }
  },
  components: {
    Entity
  }
}
</script>

<style lang="stylus" scoped>
.article
  &-content
    display flex
    .spc_img
      font-size 0
      position relative
      width 220px
      height 138px
      margin-right 20px
      overflow hidden
      .collect-icon
        position absolute
        top 10px
        right 10px
        width 18px
        height 18px
        text-align center
        line-height 18px
        color #ccc
        background-color #f3f3f3
        border-radius 2px
        font-size 10px
        display inline-block
        cursor pointer
        &:hover
        &.active
          color #fff
          background rgba(250, 122, 80, 1)
      a 
        display block
        position relative
        .play
          position absolute
          width 60px
          height 60px
          background-color rgba(#000, 0.6)
          border-radius 50% 
          z-index 1
          top 50% 
          left 50% 
          transform translate(-30px, -30px)
          text-align center
          line-height 60px
          i 
            color #fff
            font-size 28px
        .duration
          position absolute
          bottom 0
          right 0
          background-color rgba(#000, 0.6)
          color #fff
          font-weight 500
          z-index 1
          min-width 65px
          padding 0 10px
          height 22px 
          line-height 22px
          font-size 13px
          text-align center
        img
          width 220px
          height 138px
          &:hover
            transform scale(1.1)
            transition all 0.6s ease 0s
    .spc_cnt 
      position relative
      flex 1
      .h1 
        color #333
        font-weight 550
        font-size 18px
        line-height 24px
        transition all .5s
        cursor pointer
        &:hover 
          color #FA5A00
      h2 
        font-size 13px
        font-weight 500
        color #666666
        line-height 20px
        margin-top 10px
      .bot_cnt
        position absolute
        bottom 0
        left 0
        width 100%
        display flex 
        justify-content space-between
        align-items flex-end
        >div:first-child 
          flex 1
        .tags1 , .tags2
          span 
            font-size 12px
            font-family PingFang SC
            font-weight 500
            color #999999
            line-height 18px
        .tags1
          a 
            background #FFF8F1
            border-radius 13px
            font-size 12px
            font-family PingFang SC
            font-weight 400
            color #FA5A00
            line-height 1
            padding 6px 8px
            display inline-block
            margin-left 10px
            transition all .5s
            &:first-child
              margin-left 15px
            &:hover 
              background #FA5A00
              color #fff
        .tags2
          margin-top 10px
          a 
            font-size 12px
            font-weight 400
            color #FA5A00
            display inline-block
            margin-left 10px
            line-height 1
            transition all .5s
            &:first-child
              margin-left 15px
            &:hover 
              color #FF4800
        .auth_time
          text-align right
          color #999
          font-size 12px
          font-weight 500
          display flex 
          align-items center
          span 
            line-height 24px
            i 
              margin-right 6px
              font-size 12px
              height 11px
              display inline-block
              line-height 24px
          .author
            font-size 12px
            color #FA5A00
            margin-right 9px
            cursor pointer
            &:hover 
              color #FF4800
              transition all .5s
          img 
            width 20px
            height 20px
            border-radius 50%
            margin-right 5px
            cursor pointer
  
</style>
